import * as angular from 'angular';
import { NotificationService } from '../../../../../app.common/modules/common/services/notification.service';
import { StateService } from '@uirouter/core';
import * as moment from 'moment';
import { OperationService } from '../../operation.service';
import { OperationMessageStatus, IOperationFilter, IOperationStatistic, IOperationStatisticModel, OperationMessageSource, OperationMessageKind } from '../../models';
import * as _ from 'underscore';

interface IPageParams {
    page: number;
    filter: string;
    from: string;
    to: string;
}

const itemsLimit: number = 50;

export class OperationListComponent implements ng.IComponentController {
    static $inject = ['operationService', 'notificationService', '$state', '$translate'];

    readonly filterOptions = [
        { name: this.$translate.instant('all_statuses'), value: null },
        { name: this.$translate.instant('enqueued'), value: 'enqueued'},
        { name: this.$translate.instant('processing'), value: 'processing'},
        { name: this.$translate.instant('processed'), value: 'processed'}
    ];

    waiting: boolean;
    items: IOperationStatisticModel[] = [];
    total: number;
    from: Date;
    to: Date;
    page: number;
    filter: { name: string, value: string };
    onFileUploadPromise: ng.IPromise<void>;

    private readonly filterMap = {
        ['enqueued']: OperationMessageStatus.Enqueued,
        ['processing']: OperationMessageStatus.Processing,
        ['processed']: OperationMessageStatus.Processed
    };

    private canLoadMore: boolean = true;

    constructor(
        private readonly operationService: OperationService,
        private readonly notificationService: NotificationService,
        private readonly $state: StateService,
        private readonly $translate: angular.translate.ITranslateService
    ) {
        this.page = 1;
        this.from = moment().add(-7, 'days').startOf('day').toDate();
        this.to = moment().endOf('day').toDate();
        this.filter = this.filterOptions[0];
    }

    $onInit() {
        this.loadData();
        if (this.onFileUploadPromise) {
            this.onFileUploadPromise.then(angular.noop, angular.noop, (operation: IOperationStatisticModel) => this.items.unshift(operation));
        }
    }

    openOperation(id: string) {
        this.$state.go('app.operation', { id: id });
    }

    goToHelp() {
        this.$state.go('app.help.manual');
    }

    refresh() {
        this.items = [];
        this.canLoadMore = true;
        this.loadData();
    }

    private loadData() {
        if (this.waiting || !this.canLoadMore) {
            return;
        }

        this.waiting = true;
        let status = this.filter ? this.filter.value : undefined;
        let pageParams = this.getPageParams();

        let lastItem = _.last(this.items);
        let lastItemId = lastItem ? lastItem.RequestTimeStamp : undefined;

        let filter: IOperationFilter = {
            from: pageParams.from,
            to: pageParams.to,
            searchAfter: moment(lastItemId).toISOString(),
            limit: itemsLimit,
            status: this.filterMap[status]
        };

        this.notificationService.showWaitingMessage();

        return this.operationService.getOperationList(filter)
            .then((response) => {
                this.total = response.Total;
                Array.prototype.push.apply(this.items, response.Items);
                this.canLoadMore = response.Items.length === itemsLimit;
            })
            .catch(error => this.notificationService.showErrorMessage(error))
            .finally(() => {
                this.waiting = false;
                this.notificationService.clearAll();
            });
    }

    private getPageParams(): IPageParams {
        let filter = this.filter ? this.filter.value : undefined;

        return {
            page: this.page,
            filter: filter,
            from: moment(this.from).startOf('day').toISOString(),
            to: moment(this.to).endOf('day').toISOString()
        };
    }
}

angular
    .module('naut')
    .component('operationList', {
        template: require('./operation-list.component.html'),
        controller: OperationListComponent,
        bindings: {
            'onFileUploadPromise': '<'
        }
     });



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/inventory/components/operation-list/operation-list.component.ts